import { TenantScopeProvider } from "./scope/TenantScopeContext";
import GlobalScopeShell from "./components/GlobalScopeShell";
import { installGlobalScopeFetchInterceptor } from "./scope/globalScopeFetch";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

installGlobalScopeFetchInterceptor();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TenantScopeProvider>
        <GlobalScopeShell />
        <App />
      </TenantScopeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
